import { ArrowsLeftRightIcon, CardsThreeIcon, UsersIcon, WalletIcon } from "@phosphor-icons/react";
import StatsCard from "components/BasicStatsCard";
import SidebarLayout from "components/Layout/Layout";
import { useData } from "components/provider/data";
import ActiveTradingAccountList from "pages/Dasboard/MainDashBoard/component/AccountTable";

const TrandingAccountMainPage = () => {
    const { activeUsers , allAccountBalance , total_trade ,totalAccounts } = useData();
    return (
        <SidebarLayout
            title={
                (
                    <h4 className="text-2xl font-bold !m-0 py-4">
                        Trading Account Dashboard
                    </h4>
                )
            }
        >
            <div className="grid lg:!grid-cols-4 grid-cols-1 gap-4 w-full ">
                <StatsCard
                    title="Total Accounts"
                    icons={<CardsThreeIcon size={24} />}
                    value={totalAccounts}
                    iconBackgroundColor="#f0f0f0"
                />
                <StatsCard
                    title="Active Users"
                    icons={<UsersIcon size={24} />}
                    value={activeUsers}
                    iconBackgroundColor="#f0f0f0"
                />
                <StatsCard
                    title="Total Balance"
                    icons={<WalletIcon size={24} />}
                    value={allAccountBalance}
                    iconBackgroundColor="#f0f0f0"
                />
                <StatsCard
                    title="Total Trades"
                    icons={<ArrowsLeftRightIcon size={24} />}
                    value={total_trade}
                    iconBackgroundColor="#f0f0f0"
                />
            </div>
            <div className="mt-6">
                <ActiveTradingAccountList />
            </div>
        </SidebarLayout>
    );
}

export default TrandingAccountMainPage;